// 之後離開頁面時清除的 redux action type 改用這裡的

export const RESET_PAGE = {
  PROFILE: 'resetReduxForProfilePage',
  NOTIFICATION: 'resetReduxForNotificationPage',
};

export const RESET_IS_REGISTER = 'resetIsRegister';
